// These are the pages you can go to.
// They are all wrapped in the App component, which should contain the navbar etc
// See http://blog.mxstbr.com/2016/01/react-apps-with-pages for more information
// about the code splitting business
import { getAsyncInjectors } from "utils/asyncInjectors";
import { push } from "react-router-redux";

const errorLoading = (err) => {
  console.error("Dynamic page loading failed", err); // eslint-disable-line no-console
};

const loadModule = (cb) => (componentModule) => {
  cb(null, componentModule.default);
};
export default function createRootComponent(store) {
  const { injectReducer, injectSagas } = getAsyncInjectors(store); // eslint-disable-line no-unused-vars
  return {
    getComponent(nextState, cb) {
      const importModules = Promise.all([
        import("containers/App/sagas"),
        import("containers/App"),
        import("containers/App/reducer"),
      ]);

      const renderRoute = loadModule(cb);

      importModules.then(([sagas, component, reducer]) => {
        injectSagas(sagas.default);
        injectReducer("App", reducer.default);
        renderRoute(component);
      });

      importModules.catch(errorLoading);
    },
    childRoutes: createRoutes(store),
  };
}
function createRoutes(store) {
  // Create reusable async injectors using getAsyncInjectors factory
  const { injectReducer, injectSagas } = getAsyncInjectors(store); // eslint-disable-line no-unused-vars

  return [
    {
      path: "/",
      name: "home",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Dashboard/reducer"),
          import("containers/Dashboard/sagas"),
          import("containers/Dashboard"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Dashboard", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },

    {
      path: "/workflows",
      name: "WorkflowsLandingPage",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/WorkflowsLandingPage/Store/reducer"),
          import("containers/WorkflowsLandingPage/Store/sagas"),
          import("containers/WorkflowsLandingPage"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("WorkflowsLandingPage", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
      },
    },
    {
      path: "/scoreReports",
      name: "DynamicScoreReports",
      getComponent(nextState, cb) {
        import("containers/DynamicScoreReports")
          .then(loadModule(cb))
          .catch(errorLoading);
      },
    },
    {
      path: "/sso",
      name: "ssoHome",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Dashboard/reducer"),
          import("containers/Dashboard/sagas"),
          import("containers/Dashboard"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Dashboard", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    // {
    //   path: '/sso/auth0',
    //   name: 'ssoAuth0',
    //   getComponent(nextState, cb) {
    //     const importModules = Promise.all([
    //       import('containers/Dashboard/reducer'),
    //       import('containers/Dashboard/sagas'),
    //       import('containers/Dashboard')
    //     ]);

    //     const renderRoute = loadModule(cb);

    //     importModules.then(([reducer, sagas, component]) => {
    //       injectReducer('Dashboard', reducer.default);
    //       injectSagas(sagas.default);
    //       renderRoute(component);
    //     });
    //     importModules.catch(errorLoading);
    //   }
    // },
    {
      path: "/dashboard",
      name: "Dashboard",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Dashboard/reducer"),
          import("containers/Dashboard/sagas"),
          import("containers/Dashboard"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Dashboard", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    {
      path: "/jobs",
      name: "Jobs",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/JobsLandingPage/reducer"),
          import("containers/JobsLandingPage/sagas"),
          import("containers/JobsLandingPage"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("JobsLandingPage", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    {
      path: "/landingPages",
      name: "LandingPages",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/LandingPages/reducer"),
          import("containers/LandingPages/sagas"),
          import("containers/LandingPages"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("LandingPages", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    {
      path: "/landingPages_form",
      name: "LandingPages",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/LandingPages/reducer"),
          import("containers/LandingPages/sagas"),
          import("containers/LandingPages"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("LandingPages", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/landingPages_form_v2",
      name: "LandingPages",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/LandingPages/reducer"),
          import("containers/LandingPages/sagas"),
          import("containers/LandingPages"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("LandingPages", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/results",
      name: "results",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Results/reducer"),
          import("containers/Results/sagas"),
          import("containers/Results"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("results", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/exitPages",
      name: "ExitPages",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/ExitPages/reducer"),
          import("containers/ExitPages/sagas"),
          import("containers/ExitPages"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("ExitPages", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/exitPages_form",
      name: "ExitPages",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/ExitPages/reducer"),
          import("containers/ExitPages/sagas"),
          import("containers/ExitPages"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("ExitPages", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "ratings",
      name: "Ratings",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Ratings/reducer"),
          import("containers/Ratings/sagas"),
          import("containers/Ratings"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Ratings", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "testmaker",
      name: "TestMaker",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/TestMakerTests/reducer"),
          import("containers/TestMakerTests/sagas"),
          import("containers/TestMakerTests"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("TestMakerTests", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "emailTemplates",
      name: "emailTemplates",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/EmailTemplates/reducer"),
          import("containers/EmailTemplates/sagas"),
          import("containers/EmailTemplates"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("EmailTemplates", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/emailTemplate_form",
      name: "emailTemplates",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/EmailTemplates/reducer"),
          import("containers/EmailTemplates/sagas"),
          import("containers/EmailTemplates"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("EmailTemplates", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "testbatteries",
      name: "TestBatteries",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/TestBatteries/reducer"),
          import("containers/TestBatteries/sagas"),
          import("containers/TestBatteries"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("TestBatteries", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "Pipelines",
      name: "Pipelines",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Pipelines/reducer"),
          import("containers/Pipelines/sagas"),
          import("containers/Pipelines"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Pipelines", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/accessRoles",
      name: "accessRoles",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/AccessRoles/reducer"),
          import("containers/AccessRoles/sagas"),
          import("containers/AccessRoles"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("accessRoles", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "jobApplications",
      name: "jobApplications",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/JobApplications/reducer"),
          import("containers/JobApplications/sagas"),
          import("containers/JobApplications"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("jobApplications", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "users",
      name: "users",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Users/reducer"),
          import("containers/Users/sagas"),
          import("containers/Users"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("users", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/jobApplications_form",
      name: "jobApplications",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/JobApplications/reducer"),
          import("containers/JobApplications/sagas"),
          import("containers/JobApplications"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("jobApplications", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/jobApplications_questions",
      name: "jobApplications",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/JobApplications/reducer"),
          import("containers/JobApplications/sagas"),
          import("containers/JobApplications"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("jobApplications", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/teams",
      name: "teams",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Teams/reducer"),
          import("containers/Teams/sagas"),
          import("containers/Teams"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("teams", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/companyPreferences",
      name: "companyPreferences",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/CompanyPreferences/reducer"),
          import("containers/CompanyPreferences/sagas"),
          import("containers/CompanyPreferences"),
        ]);
        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("companyPreferences", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    {
      path: "/reports",
      name: "reports",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Reports/reducer"),
          import("containers/Reports/sagas"),
          import("containers/Reports"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("reports", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/userPreferences",
      name: "userPreferences",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/UserPreferences/reducer"),
          import("containers/UserPreferences/sagas"),
          import("containers/UserPreferences"),
        ]);
        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("userPreferences", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/reports_data_form",
      name: "reports",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Reports/reducer"),
          import("containers/Reports/sagas"),
          import("containers/Reports"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("reports", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/ratings_form",
      name: "ratings",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Ratings/reducer"),
          import("containers/Ratings/sagas"),
          import("containers/Ratings"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Ratings", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/reports_aggregate_form",
      name: "reports",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Reports/reducer"),
          import("containers/Reports/sagas"),
          import("containers/Reports"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("reports", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/reports_interview_data_form",
      name: "reports",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Reports/reducer"),
          import("containers/Reports/sagas"),
          import("containers/Reports"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("reports", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/reports_data_results",
      name: "reports",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Reports/reducer"),
          import("containers/Reports/sagas"),
          import("containers/Reports"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("reports", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/reports_aggregate_results",
      name: "reports",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Reports/reducer"),
          import("containers/Reports/sagas"),
          import("containers/Reports"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("reports", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/schedule_candidates",
      name: "scheduling",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Scheduling/reducer"),
          import("containers/Scheduling/sagas"),
          import("containers/Scheduling"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Scheduling", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/testMaker_form",
      name: "testMakerTests",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/TestMakerTests/reducer"),
          import("containers/TestMakerTests/sagas"),
          import("containers/TestMakerTests"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("TestMakerTests", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/testMaker_typing_form",
      name: "testMakerTests",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/TestMakerTests/reducer"),
          import("containers/TestMakerTests/sagas"),
          import("containers/TestMakerTests"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("TestMakerTests", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/testMaker_questions",
      name: "testMakerTests",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/TestMakerTests/reducer"),
          import("containers/TestMakerTests/sagas"),
          import("containers/TestMakerTests"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("TestMakerTests", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/testMaker_analytics",
      name: "testMakerTests",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/TestMakerTests/reducer"),
          import("containers/TestMakerTests/sagas"),
          import("containers/TestMakerTests"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("TestMakerTests", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/subscribe",
      name: "subscription",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Subscription/reducer"),
          import("containers/Subscription/sagas"),
          import("containers/Subscription"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Subscription", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/payment",
      name: "payment",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Subscription/reducer"),
          import("containers/Subscription/sagas"),
          import("containers/Subscription"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Subscription", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/jobApplicationFilters",
      name: "jobApplicationFilters",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/JobApplicationFilters/reducer"),
          import("containers/JobApplicationFilters/sagas"),
          import("containers/JobApplicationFilters"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("jobApplicationFilters", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/pricing",
      name: "pricing",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Pricing/reducer"),
          import("containers/Pricing/sagas"),
          import("containers/Pricing"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("pricing", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/pipelines_form",
      name: "pipelines",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Pipelines/reducer"),
          import("containers/Pipelines/sagas"),
          import("containers/Pipelines"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Pipelines", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/testPortfolio",
      name: "testPortfolio",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/TestPortfolio/reducer"),
          import("containers/TestPortfolio/sagas"),
          import("containers/TestPortfolio"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("testPortfolio", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/testmaker_create_questions",
      name: "testMakerTests",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/TestMakerTests/reducer"),
          import("containers/TestMakerTests/sagas"),
          import("containers/TestMakerTests"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("TestMakerTests", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/search",
      name: "search",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Search/reducer"),
          import("containers/Search/sagas"),
          import("containers/Search"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("search", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/integrations",
      name: "integrations",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Integrations/reducer"),
          import("containers/Integrations/sagas"),
          import("containers/Integrations"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("integrations", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/ziprecruiter",
      name: "zipRecruiter",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/ZipRecruiter/reducer"),
          import("containers/ZipRecruiter/sagas"),
          import("containers/ZipRecruiter"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("zipRecruiter", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/ziprecruiter_success",
      name: "zipRecruiter",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/ZipRecruiter/reducer"),
          import("containers/ZipRecruiter/sagas"),
          import("containers/ZipRecruiter"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("zipRecruiter", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/integrations_order_form",
      name: "integrations",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Integrations/reducer"),
          import("containers/Integrations/sagas"),
          import("containers/Integrations"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("integrations", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/versionsInfo",
      name: "versionsInfo",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/VersionsInfo/reducer"),
          import("containers/VersionsInfo/sagas"),
          import("containers/VersionsInfo"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("versionsInfo", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/ziprecruiter_purchase",
      name: "integrations",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Integrations/reducer"),
          import("containers/Integrations/sagas"),
          import("containers/Integrations"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("integrations", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/versionUpgrade",
      name: "versionUpgrade",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/VersionUpgrade/reducer"),
          import("containers/VersionUpgrade/sagas"),
          import("containers/VersionUpgrade"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("versionUpgrade", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/version_upgrade_payment",
      name: "versionUpgrade",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/VersionUpgrade/reducer"),
          import("containers/VersionUpgrade/sagas"),
          import("containers/VersionUpgrade"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("versionUpgrade", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/ziprecruiter_upgrade",
      name: "integrations",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Integrations/reducer"),
          import("containers/Integrations/sagas"),
          import("containers/Integrations"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("integrations", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/ziprecruiter_upgrade_payment",
      name: "integrations",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Integrations/reducer"),
          import("containers/Integrations/sagas"),
          import("containers/Integrations"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("integrations", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/add_ziprecruiter_payment",
      name: "integrations",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Integrations/reducer"),
          import("containers/Integrations/sagas"),
          import("containers/Integrations"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("integrations", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/testbatteries_form",
      name: "testBatteries",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/TestBatteries/reducer"),
          import("containers/TestBatteries/sagas"),
          import("containers/TestBatteries"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("TestBatteries", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/updates",
      name: "updates",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Updates/reducer"),
          import("containers/Updates/sagas"),
          import("containers/Updates"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("updates", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/resources",
      name: "resources",
      getComponent(location, cb) {
        import("containers/Resources").then(loadModule(cb)).catch(errorLoading);
      },
    },
    {
      path: "/faq",
      name: "faq",
      getComponent(location, cb) {
        import("containers/Faq").then(loadModule(cb)).catch(errorLoading);
      },
    },
    {
      path: "/howtoGuides",
      name: "howTo",
      getComponent(location, cb) {
        import("containers/HowTo").then(loadModule(cb)).catch(errorLoading);
      },
    },
    {
      path: "/candidate",
      name: "candidatePage",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/CandidatePage/reducer"),
          import("containers/Results/reducer"),
          import("containers/CandidatePage/sagas"),
          import("containers/Results/sagas"),
          import("containers/CandidatePage"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, reducer2, sagas, sagas2, component]) => {
          injectReducer("candidatePage", reducer.default);
          injectReducer("results", reducer2.default);
          injectSagas(sagas.default);
          injectSagas(sagas2.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/resultsLanding",
      name: "resultsLanding",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/ResultsLanding/reducer"),
          import("containers/ResultsLanding/sagas"),
          import("containers/ResultsLanding"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("resultsLanding", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/scoreRanges",
      name: "scoreRanges",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/ScoreRanges/reducer"),
          import("containers/ScoreRanges/sagas"),
          import("containers/ScoreRanges"),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([reducer, sagas, component]) => {
          injectReducer("scoreRanges", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    {
      path: "/scoreRange_form",
      name: "scoreRanges",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/ScoreRanges/reducer"),
          import("containers/ScoreRanges/sagas"),
          import("containers/ScoreRanges"),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([reducer, sagas, component]) => {
          injectReducer("scoreRanges", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    {
      path: "/jobSetup",
      name: "jobSetup",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/JobSetup/reducer"),
          import("containers/JobSetup/sagas"),
          import("containers/JobSetup"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("jobSetup", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "jobSettings",
      name: "jobSettings",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/JobSettings/reducer"),
          import("containers/JobSettings/sagas"),
          import("containers/JobSettings"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("jobSettings", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },

    {
      path: "automation",
      name: "automation",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Automation/reducer"),
          import("containers/Automation/sagas"),
          import("containers/Automation"),
        ]);
        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("Automation", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/partners",
      name: "partnersCenter",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/PartnersCenter/reducer"),
          import("containers/PartnersCenter/sagas"),
          import("containers/PartnersCenter"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("partnersCenter", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/jobSetup-insight",
      name: "InsightJobCreation",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/InsightJobCreation/reducer"),
          import("containers/InsightJobCreation/sagas"),
          import("containers/InsightJobCreation"),
        ]);
        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("InsightJobCreation", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/analytics",
      name: "analytics",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/Analytics/reducer"),
          import("containers/Analytics/sagas"),
          import("containers/Analytics"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("analytics", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/assessmentSettings",
      name: "assessmentSettings",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/AssessmentSettings/reducer"),
          import("containers/AssessmentSettings/sagas"),
          import("containers/AssessmentSettings"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("assessmentSettings", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/assessmentSettingsWAA",
      name: "assessmentSettingsWAA",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/AssessmentSettingsWAA/reducer"),
          import("containers/AssessmentSettingsWAA/sagas"),
          import("containers/AssessmentSettingsWAA"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("assessmentSettingsWAA", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/workFactors_form",
      name: "assessmentSettingsWAA",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/AssessmentSettingsWAA/reducer"),
          import("containers/AssessmentSettingsWAA/sagas"),
          import("containers/AssessmentSettingsWAA"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("assessmentSettingsWAA", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/assessmentSettingsIllustrait",
      name: "assessmentSettingsIllustrait",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/AssessmentSettingsIllustrait/reducer"),
          import("containers/AssessmentSettingsIllustrait/sagas"),
          import("containers/AssessmentSettingsIllustrait"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("assessmentSettingsIllustrait", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/competencySet_form",
      name: "assessmentSettingsIllustrait",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/AssessmentSettingsIllustrait/reducer"),
          import("containers/AssessmentSettingsIllustrait/sagas"),
          import("containers/AssessmentSettingsIllustrait"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("assessmentSettingsIllustrait", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/interviewTemplates",
      name: "InterviewTemplates",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/InterviewTemplates/reducer"),
          import("containers/InterviewTemplates/sagas"),
          import("containers/InterviewTemplates"),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([reducer, sagas, component]) => {
          injectReducer("InterviewTemplates", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    {
      path: "/interviewTemplates_form",
      name: "InterviewTemplates",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/InterviewTemplates/reducer"),
          import("containers/InterviewTemplates/sagas"),
          import("containers/InterviewTemplates"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("InterviewTemplates", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/interviewTemplates_questions",
      name: "InterviewTemplates",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/InterviewTemplates/reducer"),
          import("containers/VideoLibrary/Library/reducer"),
          import("containers/InterviewTemplates/sagas"),
          import("containers/VideoLibrary/Library/sagas"),
          import("containers/InterviewTemplates"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, reducer2, sagas, sagas2, component]) => {
          injectReducer("InterviewTemplates", reducer.default);
          injectReducer("VideoLibrary", reducer2.default);
          injectSagas(sagas.default);
          injectSagas(sagas2.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    {
      path: "/contentlibrary",
      name: "contentLibrary",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/VideoLibrary/Library/reducer"),
          import("containers/VideoLibrary/Library/sagas"),
          import("containers/VideoLibrary"),
        ]);
        const renderRoute = loadModule(cb);
        importModules.then(([reducer, sagas, component]) => {
          injectReducer("VideoLibrary", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });
        importModules.catch(errorLoading);
      },
    },
    {
      path: "/videoInterviewDiscovery",
      name: "videoInterviewDiscovery",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/VideoInterviewDiscovery/reducer"),
          import("containers/VideoInterviewDiscovery/sagas"),
          import("containers/VideoInterviewDiscovery"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("VideoInterviewDiscovery", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/createJob",
      name: "jobCreation",
      getComponent(location, cb) {
        const importModules = Promise.all([
          import("containers/JobCreation/reducer"),
          import("containers/JobCreation/sagas"),
          import("containers/JobCreation"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("JobCreation", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/createJob_videoInterview",
      name: "jobCreation",
      getComponent(location, cb) {
        const importModules = Promise.all([
          import("containers/JobCreation/reducer"),
          import("containers/JobCreation/sagas"),
          import("containers/JobCreation"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("JobCreation", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/createJob_videoInterviewConfiguration",
      name: "jobCreation",
      getComponent(location, cb) {
        const importModules = Promise.all([
          import("containers/JobCreation/reducer"),
          import("containers/JobCreation/sagas"),
          import("containers/JobCreation"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("JobCreation", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/createJob_liveInterview",
      name: "jobCreation",
      getComponent(location, cb) {
        const importModules = Promise.all([
          import("containers/JobCreation/reducer"),
          import("containers/JobCreation/sagas"),
          import("containers/JobCreation"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("JobCreation", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/createJob_liveInterviewConfiguration",
      name: "jobCreation",
      getComponent(location, cb) {
        const importModules = Promise.all([
          import("containers/JobCreation/reducer"),
          import("containers/JobCreation/sagas"),
          import("containers/JobCreation"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("JobCreation", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/createJob_occupation",
      name: "jobCreation",
      getComponent(location, cb) {
        const importModules = Promise.all([
          import("containers/JobCreation/reducer"),
          import("containers/JobCreation/sagas"),
          import("containers/JobCreation"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("JobCreation", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/videoInterview",
      name: "videoInterview",
      onEnter: () => {
        store.dispatch(push("/interviewTemplates"));
      },
    },
    {
      path: "/videoInterview_form",
      name: "videoInterview",
      onEnter: () => {
        store.dispatch(push("/interviewTemplates"));
      },
    },
    {
      path: "/accountBillingDetails",
      name: "accountBillingDetails",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/AccountBillingDetails/reducer"),
          import("containers/AccountBillingDetails/sagas"),
          import("containers/AccountBillingDetails"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer("AccountBillingDetails", reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/assessmentLibrary",
      name: "assessmentLibrary",
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import("containers/AssessmentLibrary"),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/packagingPage",
      name: "packagingPage",
      getComponent(nextState, cb) {
        const importModules = Promise.all([import("containers/PackagingPage")]);

        const renderRoute = loadModule(cb);

        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "/comparePlans",
      name: "comparePlans",
      getComponent(nextState, cb) {
        const importModules = Promise.all([import("containers/ComparePlans")]);

        const renderRoute = loadModule(cb);

        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: "*",
      name: "notfound",
      getComponent(nextState, cb) {
        import("containers/NotFoundPage")
          .then(loadModule(cb))
          .catch(errorLoading);
      },
    },
  ];
}
